import { Api } from '~/myApi'

export const api = new Api({
  baseUrl: process.env.REACT_APP_API_PATH!,
  baseApiParams: {
    credentials: "include"
  }
})

export default api.api